export default {
    user: {
        create: {
            title: "Új felhasználó",
            model: {
                email: {
                    label: "Email",
                    placeholder: "E-mail cím kitöltése"
                },
                name: {
                    label: "Név",
                    placeholder: "Kitöltési név"
                },
                country: {
                    label: "Ország",
                    placeholder: "Töltse ki az országot"
                },
                approval_manager_email: {
                    label: "Menedzser e-mail címe",
                    placeholder: "Írja be a vezető e-mail címét",
                    errors: {
                        different: "A jóváhagyási vezető e-mail címének el kell térnie a felhasználói e-mail címtől."
                    }
                }
            },
            cta: {
                submit: {
                    text: "Küldés",
                    processing: "Beküldés"
                },
                cancel: {
                    text: "Mégsem"
                }
            }
        },
        country: {
            title: "Felhasználó országa",
            header: "{email} felhasználóhoz nincs kiválasztva ország. Kérjük, válassza ki az országot.",
            model: {
                country: {
                    label: "Ország",
                    placeholder: "Töltse ki az országot"
                }
            },
            cta: {
                submit: {
                    text: "Küldés",
                    processing: "Beküldés"
                },
                cancel: {
                    text: "Mégsem"
                }
            }
        }
    }
}